import React, {Component} from 'react';
import '../styles/Blank.css';

class Blank extends Component {
    render() {
        const {className} = this.props;

        return (
            <div className={`blank${className?' '+className:''}`}></div>
        );
    }
}

export default Blank;


// WEBPACK FOOTER //
// ./src/components/Blank.js